import { IPengguna } from '@/data/Pengguna'
import { User } from 'firebase/auth'
import { createStore } from 'vuex'

const store = createStore({
  state: {
    bukaModal: false,
    jenisModal: "LOGIN" as TJenisModal,
    login: false,
    user: null as User | null,
    pengguna: null as IPengguna | null,
  },
  mutations: {
    bukaModal(state, jenis: TJenisModal = null){
      if(jenis === null){
        state.bukaModal = false
        state.jenisModal = jenis
        return
      }
      state.bukaModal = !state.bukaModal
      state.jenisModal = jenis
    },
    tutupModal(state){
      state.bukaModal = false
    },
    login(state, user: User | null){
      user !== null ? state.login = true : state.login = false
      state.user = user
    },
    tambahPengguna(state, pengguna: IPengguna | null){
      state.pengguna = pengguna
    }
  },
  actions: {
    bukaModal({commit}, data: TJenisModal = null){
      commit('bukaModal', data)
    },
    tutupModal({commit}){
      commit('tutupModal')
    },
    login({commit}, data: User | null = null){
      commit('login', data)
    },
    tambahPengguna({commit}, data: IPengguna | null = null){
      commit('tambahPengguna', data)
    },
  },
  modules: {
  },
  getters:{
  }
})

type TJenisModal = "LOGIN" | "LAIN" | null

export default store